"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionConfig = exports.currentSectionName = void 0;
const odSurveyHelper = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const helper_1 = require("../../common/helper");
exports.currentSectionName = 'personsTrips';
const previousSectionName = 'household';
const nextSectionName = 'longDistance';
// Config for the section
exports.sectionConfig = {
    previousSection: previousSectionName,
    nextSection: nextSectionName,
    title: {
        fr: 'Sélection du membre du ménage',
        en: 'Household member selection'
    },
    navMenu: {
        type: 'inNav',
        menuName: {
            fr: 'Déplacements',
            en: 'Trips'
        }
    },
    widgets: [],
    enableConditional: function (interview) {
        return (0, helper_1.householdMembersSectionComplete)(interview);
    },
    completionConditional: function (interview) {
        const persons = odSurveyHelper.getInterviewablePersonsArray({ interview });
        return ((0, helper_1.householdMembersSectionComplete)(interview) &&
            persons.every((person) => (0, helper_1.tripDiaryAndTravelBehaviorForPersonComplete)(person, interview)));
    },
    repeatedBlock: {
        iterationRule: {
            type: 'builtin',
            path: 'interviewablePersons'
        },
        order: 'random',
        selectionSectionId: 'selectPerson',
        skipSelectionInNaturalFlow: true,
        activeSurveyObjectPath: '_activePersonId',
        pathPrefix: 'person',
        sections: ['selectPerson', 'tripsIntro', 'visitedPlaces', 'segments', 'travelBehavior'],
        isIterationValid: (interview, iterationContext) => {
            const personId = iterationContext[iterationContext.length - 1];
            const person = odSurveyHelper.getPerson({ interview, personId });
            return (0, helper_1.tripDiaryAndTravelBehaviorForPersonComplete)(person, interview);
        }
    }
};
exports.default = exports.sectionConfig;
